<template>
    <div class="wrapper">
      <div class="type" >
        <div class="type-top">
          <div class="type-top-left"></div>
          第二类医疗器械备案凭证
        </div>
        <div class="type-text">
          <div class="CodeText">
            备案号： <span>{{ RejectListProps.BRFilingCode }}</span>
          </div>
          <div class="CodeText">
            企业名称： <span>{{ RejectListProps.BRCompanyName }}</span>
          </div>
          <div class="CodeText">
            经营方式： <span>{{ RejectListProps.BRBusinessMode }}</span>
          </div>
          <div class="CodeText">
            住所： <span>{{ RejectListProps.BRAddress }}</span>
          </div>
          <div class="CodeText">
            经营场所： <span>{{ RejectListProps.BRBusinessAddr }}</span>
          </div>
          <div class="CodeText">
            库房地址： <span>{{ RejectListProps.BRWarehouseAddr }}</span>
          </div>
          <div class="CodeText">
            法定代表人： <span>{{ RejectListProps.BRLegalRepresentative }}</span>
          </div>
          <div class="CodeText">
            企业负责人： <span>{{ RejectListProps.BRCEO }}</span>
          </div>
          <div class="CodeText">
            二类经营范围： <span>{{ RejectListProps.BRSecInvSort }}</span>
          </div>
          <div class="CodeText">
            备案日期： <span>{{ RejectListProps.BRFilingDate }}</span>
          </div>
          <div class="CodeText">
            提交时间： <span>{{ RejectListProps.CreateTime }}</span>
          </div>
          <div class="CodeText">
            审核时间： <span>{{ RejectListProps.VerifyTime }}</span>
          </div>
          <div class="CodeText">
            驳回时间：<span>{{ RejectListProps.RejectTime }}</span>
          </div>
          <div class="CodeText">
            第二类医疗器械备案凭证
            <div class="imgBox">
              <!-- ${ config.http_URL } + -->
              <img :src="`${RejectListProps.BRPhotoURL}`">
            </div>
            <div class="imgTop4"><img src="../../../../../assets/channel/firstbusiness/phontsD.png" alt="" class="imgPhoto" @click="imgShowClick(RejectListProps.BRPhotoURL)"></div>
          </div>
          <div class="CodeText">
            驳回原因： <span>{{ RejectListProps.RejectReason }}</span>
          </div>

        </div>
      </div>
  </div>
</template>

<script>
  export default {
    components:{},
    props:{
        RejectListProps: {
            type: Object
        }
    },
    data(){
      return {

      }
    },
    created(){},
    mounted(){},
    activated(){},
    updated(){},
    methods:{
        imgShowClick(URL) {
            this.$emit('imgShowClick',URL)
        }
    },
    computed:{},
    watch:{},
  }
</script>
<style scoped lang='less'>
@import url('../index.less');
</style>